import * as React from 'react';
import {
    Breadcrumb as AntdBreadcrumb,
    Tooltip,
    Typography,
} from 'antd';
const { Text, Link } = Typography;

type Props = {
    hierarchy: { uuid: string | undefined, name: string }[],
    style?: React.CSSProperties
    onSearch: (hierarchy: { uuid: string | undefined, name: string }[]) => void
};

const Breadcrumb: React.FC<Props> = ({
    hierarchy,
    style,
    onSearch
}) => {
    const Separator = <Text>{'>'}</Text>;
    const breadcrumbItems = hierarchy
        .map((elm, idx) => {
            const isLast = idx === hierarchy.length - 1;

            if (window.innerWidth < 1280) {
                return (
                    <AntdBreadcrumb.Item key={idx}>
                        {isLast ? (
                            <Tooltip title={elm.name} trigger={['click']}>
                                <div
                                    style={{
                                        padding: '5px 16px',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        maxWidth: `${hierarchy.length === 1 ? '300px' : '180px'}`,
                                    }}>
                                    {elm.name}
                                </div>
                            </Tooltip>
                        ) : (
                            <Link
                                onClick={() => onSearch(hierarchy.slice(0, idx + 1))}
                                style={{
                                    padding: '5px 16px',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '180px',
                                    display: 'block',
                                }}>
                                {elm.name}
                            </Link>
                        )}
                    </AntdBreadcrumb.Item>
                ); 
            };

            return (
                <AntdBreadcrumb.Item key={idx}>
                    {isLast ? (
                        <Tooltip title={elm.name} trigger={['hover', 'click', 'focus']}>
                            <div
                                style={{
                                    padding: '5px 16px',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    maxWidth: `${hierarchy.length === 1 ? 'auto' : '400px'}`,
                                }}>
                                {elm.name}
                            </div>
                        </Tooltip>
                    ) : (
                        <Tooltip title={elm.name} trigger={['hover', 'click', 'focus']}>
                            <Link
                                onClick={() => onSearch(hierarchy.slice(0, idx + 1))}
                                style={{
                                    padding: '5px 16px',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '400px',
                                    display: 'block',
                                }}>
                                {elm.name}
                            </Link>
                        </Tooltip>
                    )}
                </AntdBreadcrumb.Item>
            );
        });

    return (
        <AntdBreadcrumb separator={Separator} style={style}>
            {breadcrumbItems}
        </AntdBreadcrumb>
    );
}

export default Breadcrumb;